import { beLinkRequest } from '@be-link/request';

import { Service } from './index';

/**
 * 获取飞书表格元数据请求接口
 */
interface IGetFeishuTableMetaDataReq {
  /** 飞书表格URL */
  url: string;
}

/**
 * 获取飞书表格元数据响应接口
 */
interface IGetFeishuTableMetaDataRes {
  /** 表格Id */
  tableId: string;
  /** 表格名称 */
  tableName: string;
  /** 视图Id */
  viewId: string;
  /** ObjectToken */
  objToken: string;
  /** 表头 */
  columnNames: string[];
}

/**
 * 获取任务详情
 * @param param 任务ID
 * @returns 任务详细信息
 */
export async function getFeishuTaskDetail(param: { id: string }): Promise<ITask> {
  const res = await beLinkRequest.request<ITask>({
    url: Service.DitingServer.taskUrl('/get-detail'),
    data: param,
  });
  return res.data;
}

/**
 * 更新任务
 * @param param 更新任务请求参数
 * @returns 更新任务结果
 */
export async function updateFeishuTask(param: {
  id: string;
  nodes: Array<{
    id: string;
    type: string;
    meta: {
      position: { x: number; y: number };
    };
    data: any;
  }>;
}): Promise<ITask> {
  const res = await beLinkRequest.request<ITask>({
    url: Service.DitingServer.taskUrl('/update'),
    method: 'POST',
    data: param,
  });
  return res.data;
}

/**
 * 创建任务
 * @param param 创建任务请求参数
 * @returns 创建任务结果
 */
export async function createFeishuTask(param: {
  name: string;
  nodes: Array<{
    id: string;
    type: string;
    meta: {
      position: { x: number; y: number };
    };
    data: any;
  }>;
}): Promise<ITask> {
  const res = await beLinkRequest.request<ITask>({
    url: Service.DitingServer.taskUrl('/create'),
    method: 'POST',
    data: param,
  });
  return res.data;
}

/**
 * 根据飞书表格url获取表格元数据
 * @param param 包含飞书表格URL的请求参数
 * @returns 表格元数据信息
 */
export async function getFeishuTableMetaData(
  param: IGetFeishuTableMetaDataReq
): Promise<{ data: IGetFeishuTableMetaDataRes }> {
  const res = await beLinkRequest.request<IGetFeishuTableMetaDataRes>({
    url: Service.DitingServer.taskUrl('/get-feishu-table-meta-data'),
    method: 'POST',
    data: param,
  });
  return { data: res.data };
}
